/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { STAGE_DATA_COMPLETED_LAWFIRM, STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT } from "../../Stages/StagesCase";
import { previewClaimLetterButton, previewFeedbackMessageButton } from "./litigationCaseDetailsSpecialActions";
import { TrafficAccident } from "../../../types/Products/TrafficLaw/TrafficAccident/TrafficAccident";

export const trafficAccidentCaseDetailsSpecialActions = (product: TrafficAccident) => {
  let specialActions = [];

  if (product.stage === STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT) {
    specialActions.push(previewFeedbackMessageButton(product));
  }

  if (product.stage === STAGE_DATA_COMPLETED_LAWFIRM) {
    specialActions.push(previewClaimLetterButton(product));
  }

  if (specialActions.length === 0) {
    return null;
  }

  return specialActions;
};
